/**
 * 인증 실패 시 로그인 페이지로 리다이렉트
 *
 * React Router 밖에서도 동작하도록 window.location 사용
 * 이미 로그인 페이지에 있으면 리다이렉트하지 않음
 */
export const redirectToLogin = () => {
  // 현재 경로가 이미 /login이면 리다이렉트하지 않음
  if (window.location.pathname === '/login') {
    return
  }

  // 로그인 페이지로 리다이렉트
  window.location.replace('/login')
}

